import * as Chartist from "chartist";
import "customLibs/chartist-plugin-tooltip/chartist-plugin-tooltip";
import "customLibs/chartist-plugin-tooltip/chartist-plugin-tooltip.css";
import "chartist-plugin-legend";
import "chartist-plugin-legend/"


const delays = 80, durations = 500;

export const getDailySalesChart = (data, toolTipHeader) => ({
    data: {
        labels: data.map((prop, key) => key + 1),
        series: [data.map((prop) => ({
            meta: toolTipHeader,
            value: prop,
        }))]
    },
    options: {
        lineSmooth: Chartist.Interpolation.cardinal({
            tension: 0
        }),
        low: 0,
        high: Math.max(...data.filter(n => n)) * 1.1,
        chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 10
        },
        plugins: [
            Chartist.plugins.tooltip({
                anchorToPoint: true,
            })
        ],
        height: 200,
        fullWidth: true,
    },
    // for animation
    animation: {
        draw: function(data) {
            if (data.type === "line" || data.type === "area") {
                data.element.animate({
                    d: {
                        begin: 600,
                        dur: 700,
                        from: data.path
                            .clone()
                            .scale(1, 0)
                            .translate(0, data.chartRect.height())
                            .stringify(),
                        to: data.path.clone().stringify(),
                        easing: Chartist.Svg.Easing.easeOutQuint
                    }
                });
            } else if (data.type === "point") {
                data.element.animate({
                    opacity: {
                        begin: (data.index + 1) * delays,
                        dur: durations,
                        from: 0,
                        to: 1,
                        easing: "ease"
                    }
                });
            }
        }
    }
});

export const getMonthSumSalesChart = (data, toolTipHeader) => ({
    data: {
        labels: [
            "Янв",
            "Фев",
            "Мар",
            "Апр",
            "Май",
            "Июн",
            "Июл",
            "Авг",
            "Сен",
            "Окт",
            "Ноя",
            "Дек"
        ],
        series: [[], data.map((prop) => ({
            meta: toolTipHeader,
            value: prop,
        }))]
    },
    options: {
        axisX: {
            showGrid: false
        },
        low: 0,
        high: Math.max(...data.filter(n => n)) * 1.1,
        chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
        },
        plugins: [
            Chartist.plugins.tooltip({
                anchorToPoint: true,
            })
        ],
    },
    responsiveOptions: [
        [
            "screen and (max-width: 640px)",
            {
                seriesBarDistance: 5,
                axisX: {
                    labelInterpolationFnc: function(value) {
                        return value[0];
                    }
                }
            }
        ]
    ],
    animation: {
        draw: function(data) {
            if (data.type === "bar") {
                data.element.animate({
                    opacity: {
                        begin: (data.index + 1) * delays,
                        dur: durations,
                        from: 0,
                        to: 1,
                        easing: "ease"
                    }
                });
            }
        }
    }
});

export const getShareSalesChart = (data) => ({
    data: {
        labels: data.map(prop => `${prop.id}, ${prop.address}`),
        series: data && data.length > 0 ? data[0].data.map((type, key) => ({"name": type[0], "data": data.map(prop => prop.data[key][1])})): []
    },
    options: {
        axisY: {
            showGrid: false,
            offset: 120,
        },
        low: 0,
        chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 25
        },
        stackBars: true,
        horizontalBars: true,
        plugins: [
            Chartist.plugins.legend({
            }),
            Chartist.plugins.tooltip({
            })
        ],
    },
    responsiveOptions: [
        [
            "screen and (max-width: 640px)",
            {
                seriesBarDistance: 5,
                axisX: {
                    labelInterpolationFnc: function(value) {
                        return value[0];
                    }
                }
            }
        ]
    ],
    animation: {
        draw: function(data) {
            if (data.type === "bar") {
                data.element.animate({
                    opacity: {
                        begin: (data.index + 1) * delays,
                        dur: durations,
                        from: 0,
                        to: 1,
                        easing: "ease"
                    }
                });
            }
        }
    }
});


// WEBPACK FOOTER //
// ./src/utils/charts.js